import { bookingQueryKeys } from '@/hooks/queries/booking.queries';
import { BookingService } from '@/services/booking.service';
import type { CreateBookingRequestDto } from '@/types/dto/booking.dto';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateBooking() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (payload: CreateBookingRequestDto) => BookingService.create(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: bookingQueryKeys.all });
    },
  });

  return {
    createBooking: mutation.mutateAsync,
    error: mutation.error,
    isError: mutation.isError,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
}
